import styled from "@emotion/styled";
import { Avatar, IconButton, Typography } from "@mui/material";
import theme from "../../theme";

export const AvatarIconContainer = styled(IconButton)``;

export const OrgUserAvatar = styled(Avatar)`
  height: 26px;
  width: 26px;
`;

export const MenuItemOrgUserAvatar = styled(Avatar)`
  height: 40px;
  width: 40px;
  margin-right: 10px;
`;

export const PaperProp = {
  overflow: "visible",
  filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
  mt: 1.5,
  "&:before": {
    content: '""',
    display: "block",
    position: "absolute",
    top: 0,
    right: 14,
    width: 10,
    height: 10,
    bgcolor: "background.paper",
    transform: "translateY(-50%) rotate(45deg)",
    zIndex: 0,
  },
};

export const UserName = styled(Typography)`
  margin-left: 10px;
  line-height: 22px;
`;

export const UserDesignation = styled(Typography)`
  margin-left: 10px;
  font-size: 13px;
  font-weight: 400;
  color: ${theme.palette.grey[800]};
`;
